import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { APP_Constants } from '../app.constant';
import { AppService } from '../app.service';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactUsComponent implements OnInit {
  templateData: any;

  constructor(private appService: AppService) { }

  ngOnInit(): void {
  // this.appService.makeLocalOrderSearchHNA('/contactus')
  this.appService.makeHttpGetRequest(APP_Constants.CONTACT_US_TEMPLATE +
    localStorage.getItem('customerCode') + '&userId=' +
    localStorage.getItem('userName'))
   .subscribe(
      data => {
        // this.normalView();
        // this.isLoading = false;
        if (data !== null) {
          this.appService.setOrderTemplate(data);
          this.templateData = data;
          localStorage.removeItem('copyOrderData')
        }
      },
      err => {
        console.log('error',err);
      });
 }

}
